import { z } from 'zod';
import { claimRiskLevel, Sentiment } from './claimRiskAssessment.js';
/**
 * Package protection fraud is item-not-received abuse, not return abuse, so it gets its own
 * factor set. Shares the level bands and sentiment vocabulary with the claim model so both
 * assessments render identically.
 */
export const ShippingRiskFactor = {
    //* shipment evidence — the headline group for a shipping-protection product
    reasonVsTracking: 'reasonVsTracking',
    parcelScope: 'parcelScope',
    carrierCorroboration: 'carrierCorroboration',
    claimTiming: 'claimTiming',
    alreadyMadeWhole: 'alreadyMadeWhole',
    //* financial history, from one Shopify orders-by-email call
    chargebackOverlap: 'chargebackOverlap',
    chargebackHistory: 'chargebackHistory',
    refundOverlap: 'refundOverlap',
    returnElsewhere: 'returnElsewhere',
    refundHabit: 'refundHabit',
    //* customer standing
    accountAge: 'accountAge',
    priorDeniedClaim: 'priorDeniedClaim',
    claimRateVsOrders: 'claimRateVsOrders',
    crossDomainHistory: 'crossDomainHistory',
    priorHighRiskClaim: 'priorHighRiskClaim',
    //* identifier fan-out, read across both claim domains
    emailReuseStore: 'emailReuse-store',
    emailReuseGlobal: 'emailReuse-global',
    deviceFanOut: 'deviceFanOut',
    ipFanOut: 'ipFanOut',
    addressFanOut: 'addressFanOut',
    //* claim shape
    claimCoverage: 'claimCoverage',
    evidenceProvided: 'evidenceProvided',
    mediaReuse: 'mediaReuse',
    mediaSimilarity: 'mediaSimilarity',
    reshipAddressChange: 'reshipAddressChange',
    //* fingerprint device intelligence
    botDetection: 'botDetection',
    fingerprintSuspectScore: 'fingerprintSuspectScore',
    anonymizedNetwork: 'anonymizedNetwork',
    ipReputation: 'ipReputation',
    browserTampering: 'browserTampering',
    fingerprintVelocity: 'fingerprintVelocity',
    geoDistance: 'geoDistance',
    ipAddress: 'ipAddress',
    isMerchantCreated: 'isMerchantCreated',
};
export const shippingClaimRiskAssessment = z.object({
    level: z.nativeEnum(claimRiskLevel),
    aggregateScore: z.number(),
    // optional: rows written before provenance was recorded have neither
    calculatedOn: z.string().optional(),
    modelVersion: z.string().optional(),
    facts: z.array(z.object({
        factor: z.nativeEnum(ShippingRiskFactor),
        score: z.number(),
        justification: z.string(),
        sentiment: z.nativeEnum(Sentiment),
    })),
});
//# sourceMappingURL=shippingClaimRiskAssessment.js.map